<script setup lang="ts">
import CompactId from "./CompactId.vue"

withDefaults(
  defineProps<{
    maxClass?: string
    title?: string
    value: string
  }>(),
  {
    maxClass: "max-w-[8rem]",
    title: "Credential id"
  }
)
</script>

<template>
  <CompactId prefix="cred" :max-class="maxClass" :title="title" :value="value" />
</template>
